export default {
  languages: ['en', 'de'],
  appVersion: __PLUGIN_VERSION__,
  gitHash: __PLUGIN_GIT__,
};
